/**
 * Configuration for promotional banners that appear on specific lessons
 * This centralizes the hardcoded lesson IDs and banner configurations
 */

export interface PromotionalBannerConfig {
	lessonId: number;
	type: "internal" | "external";
	href: string;
	imageUrl: string;
	alt: string;
}

export const PROMOTIONAL_BANNERS: PromotionalBannerConfig[] = [
	{
		// Banner for Mini Curso Aplicadores in ABA para Pais 2021 course
		lessonId: 855,
		type: "internal",
		href: "/cursos/mini-curso-para-aplicadores",
		imageUrl: "https://www.nossomundoazul.com.br/static/images/banner-modulo-extra-aba.jpg",
		alt: "Banner do Mini Curso para Aplicadores - Clique para acessar",
	},
	{
		// Banner for Pós Formação 2020
		lessonId: 1042,
		type: "external",
		href: "https://pos.academiadoautismo.com.br/?utm_campaign=ciaautismo&utm_source=formatura-formacao&utm_medium=banner-aula",
		imageUrl: "https://imersao.academiadoautismo.com.br/images/banner-pos.jpg",
		alt: "Banner da Pós-Graduação Academia do Autismo - Clique para saber mais",
	},
];

/**
 * Get the promotional banner configuration for a given lesson ID
 */
export const getBannerForLesson = (lessonId: number): PromotionalBannerConfig | undefined => {
	return PROMOTIONAL_BANNERS.find((banner) => banner.lessonId === lessonId);
};
